import { IStore } from '../types/IStore'

const CURRENT_STORE_KEY = 'CurrentStore'

const isStoreShape = (value: unknown): value is IStore => {
  if (!value || typeof value !== 'object') return false

  const store = value as IStore
  const hasValidStoreCode = typeof store.storeCode === 'string'
  const hasValidInScope = typeof store.inScope === 'boolean'
  const hasValidStoreName =
    store.storeName === undefined || typeof store.storeName === 'string'

  return hasValidStoreCode && hasValidInScope && hasValidStoreName
}

export const getChosenStore = (): IStore | null => {
  const savedStore = sessionStorage.getItem(CURRENT_STORE_KEY)
  if (!savedStore) return null

  try {
    const parsedStore: unknown = JSON.parse(savedStore)
    return isStoreShape(parsedStore) ? parsedStore : null
  } catch {
    return null
  }
}

export const setChosenStore = (store: IStore) => {
  sessionStorage.setItem(CURRENT_STORE_KEY, JSON.stringify(store))
}
